import React, { useEffect } from 'react';
import { Box, Grid, Divider, Container } from '@mui/material';
import ProductImageGallery from '../components/ProductImageGallery';
import ProductInfo from '../components/ProductInfo';
import RecentlyViewed from '../components/RecentlyViewed';
import { getProductById } from '../services/productService';
import { useParams } from 'react-router-dom';
import { useRecentlyViewed } from '../hooks/useRecentlyViewed';

const ProductDetails = () => {
  const { id } = useParams();
  const product = getProductById(id);
  const { recentlyViewedProducts, addToRecentlyViewed } = useRecentlyViewed();

  useEffect(() => {
    document.title = `${product.name} | My Store`;
  }, [product.name]);

  // Track this product as recently viewed
  useEffect(() => {
    if (product && product.id) {
      addToRecentlyViewed(product.id);
    }
  }, [product.id, addToRecentlyViewed]);

  return (
    <Box sx={{ 
      px: { xs: 1, sm: 2, md: 3 }, // Responsive horizontal padding
      py: { xs: 2, sm: 3 } // Responsive vertical padding
    }}>
      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
        <Grid container spacing={{ xs: 2, sm: 3 }}>
          <Grid item xs={12} md={7}>
            <ProductImageGallery product={product} />
          </Grid>
          <Grid item xs={12} md={5}>
            <ProductInfo product={product} />
          </Grid>
        </Grid>
      </Container>
      <Divider sx={{ my: { xs: 2, sm: 4 } }} />
      <Container maxWidth={false} sx={{ px: { xs: 0, sm: 2 } }}>
        <RecentlyViewed products={recentlyViewedProducts} />
      </Container>
    </Box>
  );
};

export default ProductDetails;